const renderBlocks = (body) => {
  const out = [];
  let bullets = [];
  let key = 0;
  const flush = () => {
    if (bullets.length) {
      out.push(
        <ul key={`ul-${key++}`} className="my-4 list-disc space-y-2 pl-6 text-ink2">
          {bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      );
      bullets = [];
    }
  };
  body.split("\n").forEach((line, i) => {
    if (line.startsWith("# ")) {
      flush();
      out.push(
        <h2 key={i} className="mt-10 mb-3 font-display text-2xl font-medium tracking-tight text-ink">
          {line.slice(2)}
        </h2>
      );
    } else if (line.startsWith("- ")) {
      bullets.push(line.slice(2));
    } else if (line.trim() === "") {
      flush();
    } else {
      flush();
      out.push(
        <p key={i} className="my-4 leading-relaxed text-ink2">
          {line}
        </p>
      );
    }
  });
  flush();
  return out;
};

const ArticleBody = ({ body }) => (
  <div data-testid="article-body">{renderBlocks(body || "")}</div>
);

export default ArticleBody;